import { AuthContext } from 'contexts/AuthContext';
import { useCallback, useContext, useEffect, useState } from 'react';
import { getObject, setObject } from '../utils/Storage';

const useCodes = () => {
    const { authState } = useContext(AuthContext);
    const [codes, setCodes] = useState([])

    useEffect(() => {
        async function setCodesFromStorage() {
            const storedCodes = await getObject(`oshi-codes-${authState.user.uid}`);
            if (storedCodes) setCodes(storedCodes);
        }
        setCodesFromStorage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateCodes = useCallback(async (n) => {
        setCodes(n);
        setObject(`oshi-codes-${authState.user.uid}`, n);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setCodes]);

    useEffect(() => {
        if (codes) updateCodes(codes)
    }, [codes, updateCodes])

    return [codes, setCodes]
}

export default useCodes;
